module.exports = __webpack_public_path__ + "static/media/14.c3f9f3e6.jpg";